import React, {useState} from "react";
import {Button, FormControl, Form, InputGroup} from "react-bootstrap";
import { useHouseDispatch } from "../../contexts/HouseContext";

const AddMemberForm = () => {
    const [newMemberName, setNewMemberName] = useState('')
    const [errors, setErrors] = useState(null)
    const [isSubmitPending, setIsSubmitPending] = useState(false)
    const { addMember } = useHouseDispatch();
    const onSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitPending(true);
        try {
            await addMember(newMemberName);
            setNewMemberName('');
        } catch (e) {
            console.log("Error adding member: ", e);
            setErrors({ message: e.message });
        }
        setIsSubmitPending(false);
    }

    return (
        <Form method="post" onSubmit={onSubmit}>
            <InputGroup>
                <FormControl
                    value={newMemberName}
                    onChange={(e) => setNewMemberName(e.target.value)}
                    required={true}
                    name="name"
                    placeholder="Member name..."
                />
                <Button
                    type="submit"
                    variant="outline-success"
                    disabled={isSubmitPending}
                >
                    {isSubmitPending ? "Saving..." : "Add"}
                </Button>
            </InputGroup>
            {errors ? <div className="text-danger ms-1">{errors.message}</div> : null}
        </Form>
    )
};

export default AddMemberForm;
